import { ApiResponse } from '@nohara-dxdev/oidc-core';
import { QueryConfig } from '@nohara-dxdev/react-core';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';

import type { FlagTargetState } from '@nohara-dxdev/feature-flags';

export interface UserFeatureFlagsResponse {
  flags: FlagTargetState[];
}

export const getUserFeatureFlagsQueryKey = (
  orgId: string | null | undefined,
  userId: string | null | undefined,
) => ['feature-flags', 'admin', 'user', orgId ?? '', userId ?? ''] as const;

export const getUserFeatureFlags = async (
  orgId: string,
  userId: string,
): Promise<UserFeatureFlagsResponse> => {
  const { data } = await api.get<unknown, ApiResponse<UserFeatureFlagsResponse>>(
    `/orgs/${orgId}/users/${userId}/feature-flags`,
  );
  return data;
};

export const getUserFeatureFlagsQueryOptions = (
  orgId: string | null | undefined,
  userId: string | null | undefined,
) =>
  queryOptions({
    queryKey: getUserFeatureFlagsQueryKey(orgId, userId),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => getUserFeatureFlags(orgId!, userId!),
    enabled: !!orgId && !!userId,
  });

interface UseUserFeatureFlagsOptions {
  orgId: string | null | undefined;
  userId: string | null | undefined;
  queryConfig?: QueryConfig<typeof getUserFeatureFlagsQueryOptions>;
}

export const useUserFeatureFlags = ({
  orgId,
  userId,
  queryConfig = {},
}: UseUserFeatureFlagsOptions) =>
  useQuery({ ...getUserFeatureFlagsQueryOptions(orgId, userId), ...queryConfig });
